export default __webpack_public_path__ + "static/media/users.50137044.svg";